// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FwFC6vsu7YyG_5ihMugw{padding-left:var(--spacing-lg) !important}.LdGApVYJHTt8mQSAnQGE{padding-left:58px !important}.DIRI5HRHVZgy8VAiYY77{gap:var(--spacing-xxxs)}.Q52q1Z6rhoJghYNNhNDI{gap:var(--spacing-xxxxs)}.Mcbs4ydBJllCpQ37lTeU:hover{background-color:var(--app-subNavigationPanel-iconButton-hoverColor)}.WN2OOV34MeNGfAtBGZzw{height:calc(100vh - 125px);overflow:hidden;gap:1px}.tenantBannerVisible .WN2OOV34MeNGfAtBGZzw{height:calc(100vh - (52px + 125px))}@media screen and (max-width: 768px){.WN2OOV34MeNGfAtBGZzw{height:calc(100dvh - (51px + 60px))}.tenantBannerVisible .WN2OOV34MeNGfAtBGZzw{height:calc(100dvh - (52px + 51px + 60px))}}.licgqujb2c5P0QiwAvOw::-webkit-scrollbar{width:5px;height:5px}.licgqujb2c5P0QiwAvOw{scrollbar-width:thin;scrollbar-color:var(--app-navigationPanel-scrollBarColor, var(--color-grey-300)) rgba(0,0,0,0);flex-shrink:1;min-height:40px;gap:1px}.mAhnr3J4xT4YD_durQQQ::-webkit-scrollbar{width:5px;height:5px}.mAhnr3J4xT4YD_durQQQ{scrollbar-width:thin;scrollbar-color:var(--app-navigationPanel-scrollBarColor, var(--color-grey-300)) rgba(0,0,0,0);flex-shrink:1;min-height:40px;overflow-y:auto;gap:1px}.F9iMhMzjAUbZZESijHsF{margin-bottom:var(--spacing-md)}@media screen and (max-width: 768px){.F9iMhMzjAUbZZESijHsF{margin-bottom:0px}}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigation-panel/sub-navigation-panel/contents/assets-sub-menu/assets-sub-menu.scss","webpack://./src/styles/size.scss","webpack://./src/styles/transparentScrollbar.scss"],"names":[],"mappings":"AAGA,sBACI,yCAAA,CAGJ,sBACI,4BAAA,CAGJ,sBACI,uBAAA,CAGJ,sBACI,wBAAA,CAIA,4BACI,oEAAA,CAIR,sBACI,0BAAA,CACA,eAAA,CACA,OAAA,CAEA,2CACI,mCAAA,CCuBA,qCD7BR,sBAUQ,mCAAA,CAEA,2CACI,0CAAA,CAAA,CEjCR,yCACI,SAHG,CAIH,UAJG,CF2CX,sBErCI,oBAAA,CAGI,8FAAA,CFoCJ,aAAA,CACA,eAAA,CACA,OAAA,CE7CA,yCACI,SAHG,CAIH,UAJG,CFkDX,sBE5CI,oBAAA,CAGI,8FAAA,CF2CJ,aAAA,CACA,eAAA,CACA,eAAA,CACA,OAAA,CAGJ,sBACI,+BAAA,CCRI,qCDOR,sBAIQ,iBAAA,CAAA","sourcesContent":["@use \"~styles/transparentScrollbar\" as scrollbar;\n@import \"~styles/size\";\n\n.file {\n    padding-left: var(--spacing-lg) !important;\n}\n\n.nestedFile {\n    padding-left: 58px !important;\n}\n\n.xxxsGap {\n    gap: var(--spacing-xxxs);\n}\n\n.xxxxsGap {\n    gap: var(--spacing-xxxxs);\n}\n\n.iconButton {\n    &:hover {\n        background-color: var(--app-subNavigationPanel-iconButton-hoverColor);\n    }\n}\n\n.container {\n    height: calc(100vh - #{$subNavigationHeaderHeight});\n    overflow: hidden;\n    gap: 1px;\n\n    :global(.tenantBannerVisible) & {\n        height: calc(100vh - (#{$tenantBannerHeight} + #{$subNavigationHeaderHeight}));\n    }\n\n    @include breakpoint(\"md\") {\n        height: calc(100dvh - (#{$subNavigationHeaderHeightMobile} + #{$mobileNavigationHeaderHeight}));\n\n        :global(.tenantBannerVisible) & {\n            height: calc(\n                100dvh -\n                    (#{$tenantBannerHeight} + #{$subNavigationHeaderHeightMobile} + #{$mobileNavigationHeaderHeight})\n            );\n        }\n    }\n}\n\n.scrollContainer {\n    @include scrollbar.transparentScrollbar();\n    flex-shrink: 1;\n    min-height: 40px;\n    gap: 1px;\n}\n\n.archiveFolderContainer {\n    @include scrollbar.transparentScrollbar();\n    flex-shrink: 1;\n    min-height: 40px;\n    overflow-y: auto;\n    gap: 1px;\n}\n\n.footer {\n    margin-bottom: var(--spacing-md);\n\n    @include breakpoint(\"md\") {\n        margin-bottom: 0px;\n    }\n}\n","@use \"sass:math\";\n@use \"sass:map\";\n\n// Spacing\n$spacingXxxxs: 2px;\n$spacingXxxs: 4px;\n$spacingXxs: 8px;\n$spacingXs: 12px;\n$spacingSm: 16px;\n$spacingMd: 20px;\n$spacingLg: 32px;\n$spacingXl: 40px;\n$spacingXxl: 88px;\n\n// Breakpoints\n$breakpoints: (\n    \"xs\": 458px,\n    \"sm\": 580px,\n    \"md\": 768px,\n    \"lg\": 992px,\n    \"xl\": 1200px,\n    \"xxl\": 1600px,\n);\n\n// Layout\n$headerHeight: 79px;\n$layoutHorizontalSpacingDesktop: $spacingXl;\n$layoutHorizontalSpacingMobile: $spacingMd;\n$sideNavigationWidth: 300px;\n$tenantBannerHeight: 52px;\n$bannerHeight: 44px;\n$bannerHeightMobile: $bannerHeight + 10px;\n$subNavigationHeaderHeight: 125px;\n$subNavigationHeaderHeightMobile: 51px;\n\n$navigationPanelWidth: 270px;\n$mobileNavigationHeaderHeight: 60px;\n$spacingBelowQuickSearch: 24px;\n$verticalPadding: 5px;\n$reportDocumentWidth: 960px;\n$mainNavigationPanelWidth: 60px;\n// The main navigation is an off-canvas overlay below the md breakpoint and keeps the narrower width there.\n$mobileMainNavigationPanelWidth: 52px;\n$subNavigationPanelWidth: 250px;\n// This mixin generates max-width breakpoints by default.\n// Pass in \"min\" as direction argument if you want to use a min-width breakpoint instead.\n@mixin breakpoint($name, $direction: \"max\") {\n    @if not map-has-key($breakpoints, $name) {\n        @warn \"#{$name} is not a valid breakpoint name.\";\n    } @else {\n        $breakpoint: map.get($breakpoints, $name);\n        @if $direction == \"min\" {\n            $breakpoint: $breakpoint + 1;\n        }\n        @media screen and (#{$direction}-width: $breakpoint) {\n            @content;\n        }\n    }\n}\n\n@mixin deviceOrientation($direction) {\n    @if $direction != \"landscape\" and $direction != \"portrait\" {\n        @warn \"#{$direction} is not a valid orientation.\";\n    } @else {\n        @media (orientation: #{$direction}) {\n            @content;\n        }\n    }\n}\n\n:export {\n    @each $name, $value in $breakpoints {\n        $capitalizedName: to-upper-case(str-slice($name, 1, 1)) + str-slice($name, 2);\n        breakpoint#{$capitalizedName}: $value;\n    }\n}\n","@import \"~styles/theme\";\n\n@mixin transparentScrollbar($scrollbarVariant: navigation) {\n    $size: 5px;\n\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n    scrollbar-width: thin;\n\n    @if $scrollbarVariant == navigation {\n        scrollbar-color: var(--app-navigationPanel-scrollBarColor, var(--color-grey-300)) transparent;\n    } @else if $scrollbarVariant == content {\n        scrollbar-color: var(--theme-primary) transparent;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whiteColor": `var(--color-white)`,
	"oemLicenseKeysBulkImportModal": `var(--color-grey-950)`,
	"homeViewTierTypeLabelTextColor": `var(--color-grey-500)`,
	"homeCurrentPlanRedColor": `var(--color-purple-1050)`,
	"homeCurrentPlanBlueColor": `var(--color-blue-1000)`,
	"homeCurrentPlanYellowColor": `var(--color-yellow-1000)`,
	"homeCurrentPlanIconRedColor": `var(--color-purple-800)`,
	"homeCurrentPlanIconBlueColor": `var(--color-sky-700)`,
	"homeCurrentPlanIconYellowColor": `var(--color-orange-300)`,
	"homeCardTextColor": `var(--color-grey-700)`,
	"homeCardVersionColor": `var(--color-grey-700)`,
	"homeCardBackgroundColor": `var(--color-grey-1000)`,
	"homeCardBorderColor": `var(--color-grey-950)`,
	"homeCardNameColor": `var(--color-grey-500)`,
	"homeWireIconColor": `var(--color-purple-700)`,
	"homeWireIconBackgroundColor": `var(--color-purple-300)`,
	"activeBackgroundColor": `var(--color-blue-700)`,
	"primaryButtonBackgroundColor": `var(--color-blue-700)`,
	"secondaryButtonForegroundColor": `var(--color-blue-500)`,
	"bannerBackgroundColor": `rgba(13,27,181,.5)`,
	"linkTextColor": `var(--color-blue-500)`,
	"primaryButtonBackgroundHoverColor": `var(--color-blue-800)`,
	"secondaryButtonBackgroundHoverColor": `var(--color-blue-1000)`,
	"destructiveButtonBackgroundHoverColor": `var(--color-red-900)`,
	"primaryButtonBackgroundActiveColor": `var(--color-blue-900)`,
	"destructiveButtonBackgroundColor": `var(--color-red-950)`,
	"navigationButtonBackgroundActiveColor": `var(--color-blue-1000)`,
	"chartNegativeColor": `var(--color-red-500)`,
	"chartPositiveColor": `var(--color-green-500)`,
	"chartNeutralColor": `var(--color-grey-500)`,
	"errorBackgroundColor": `var(--color-red-600)`,
	"errorBorderColor": `var(--color-red-600)`,
	"errorTextColor": `var(--color-red-600)`,
	"deleteScheduleLinkColor": `#db2828`,
	"errorWrapperBackgroundColor": `var(--color-red-400)`,
	"warningBackgroundColor": `var(--color-orange-800)`,
	"warningTextColor": `var(--color-orange-800)`,
	"secondaryWarningBackgroundColor": `var(--color-yellow-700)`,
	"secondaryWarningBorderColor": `var(--color-yellow-700)`,
	"successBorderColor": `var(--color-green-500)`,
	"successTextColor": `var(--color-green-500)`,
	"pageBackgroundColor": `var(--color-grey-1000)`,
	"wrapperBackgroundColor": `var(--color-blue-200)`,
	"urlSectionBackgroundColor": `var(--color-blue-900)`,
	"wrapperBorderColor": `var(--color-blue-500)`,
	"modelBoxBackgroundColor": `var(--color-grey-900)`,
	"contentBackgroundColor": `var(--color-grey-1000)`,
	"secondaryButtonBackgroundColor": `var(--color-grey-950)`,
	"textColor": `var(--color-white)`,
	"textGreyColor": `var(--color-grey-700)`,
	"primaryButtonForegroundColor": `var(--color-white)`,
	"bannerForegroundColor": `var(--color-grey-900)`,
	"chartOutlineColor": `var(--color-grey-1000)`,
	"modalOverlayColor": `rgba(33,32,32,.4)`,
	"contentDividerColor": `var(--color-grey-1000)`,
	"contentBorderColor": `var(--color-grey-1000)`,
	"nestedContentBorderColor": `var(--color-grey-500)`,
	"disabledButtonBackgroundColor": `var(--color-grey-500)`,
	"disabledButtonForegroundColor": `var(--color-grey-900)`,
	"inputHintColor": `var(--color-grey-500)`,
	"inputBackgroundColor": `var(--color-grey-900)`,
	"hoverBackgroundColor": `var(--color-grey-1000)`,
	"toggleCheckedBackgroundColor": `var(--color-blue-500)`,
	"toggleUncheckedBackgroundColor": `var(--color-grey-500)`,
	"chartFirstSet": `#708add`,
	"chartSecondSet": `#dd75a0`,
	"chartThirdSet": `#4a7ab6`,
	"chartForthSet": `#5f96bc`,
	"chartFifthSet": `#c4874a`,
	"chartSixthSet": `#b63e5c`,
	"chartSeventhSet": `#6c8fa9`,
	"chartEighthSet": `#f3a14e`,
	"chartNinthSet": `#88bbdb`,
	"chartTenthSet": `#e2afc3`,
	"chartEleventhSet": `#b1bfde`,
	"chartTwelfthSet": `#facf96`,
	"optional": `var(--color-white)`,
	"disabledTextColor": `var(--color-grey-900)`,
	"colorPickerBlack": `var(--color-grey-1000)`,
	"iconFillColor": `var(--theme-icon-fill-default)`,
	"sortIconRegularColor": `var(--color-grey-500)`,
	"sortIconHoverColor": `var(--color-blue-500)`,
	"sortIconActiveColor": `var(--color-white)`,
	"diamondTierBannerBorderColor": `var(--color-pink-700)`,
	"starTierBannerBorderColor": `var(--color-purple-900)`,
	"chartSuccessColor": `var(--color-green-600)`,
	"chartFailColor": `var(--color-red-800)`,
	"textFieldColor": `var(--color-grey-1000)`,
	"focusOutlineColorButton": `#d661e5`,
	"tooltipTextColor": `var(--color-grey-900)`,
	"tooltipBackgroundColor": `var(--color-grey-150)`,
	"chipBackgroundColor": `var(--color-grey-900)`,
	"chipContentColor": `var(--color-white)`,
	"chipUserIconColor": `var(--color-grey-1000)`,
	"successIconColor": `var(--color-green-500)`,
	"errorIconColor": `var(--color-red-500)`,
	"localBannerBackgroundColor": `var(--color-blue-1000)`,
	"localBannerBorderColor": `var(--color-grey-950)`,
	"errorBannerBackgroundColor": `var(--color-red-300)`,
	"localBannerTextColor": `var(--color-white)`,
	"successBadgeTextColor": `var(--color-green-200)`,
	"warningBadgeBackgroundColor": `var(--color-yellow-600)`,
	"warningBadgeTextColor": `var(--color-yellow-900)`,
	"errorBadgeBackgroundColor": `var(--color-red-950)`,
	"errorBadgeTextColor": `var(--color-white)`,
	"infoBadgeBackgroundColor": `var(--color-blue-800)`,
	"infoBadgeTextColor": `var(--color-white)`,
	"infoIconBackgroundColor": `var(--color-grey-150)`,
	"neutralBadgeBackgroundColor": `var(--color-grey-800)`,
	"neutralBadgeTextColor": `var(--color-white)`,
	"strokeColor": `var(--color-blue-900)`,
	"textHighlightForegroundColor": `linear-gradient(0deg, rgba(250, 200, 16, 0.3) 0%, rgba(250, 200, 16, 0.3) 100%)`,
	"textHighlightBackgroundColor": `var(--color-white)`,
	"skeletonLoaderBackgroundColor": `var(--color-grey-1000)`,
	"fourthLevelTierBackgroundColor": `var(--color-purple-900)`,
	"defaultStarColor": `var(--color-green-800)`,
	"addOnsCheckmarkColor": `var(--color-green-500)`,
	"warningBannerBackgroundColor": `var(--color-yellow-600)`,
	"warningBannerBorderColor": `var(--color-yellow-150)`,
	"warningBannerTextColor": `var(--color-grey-1000)`,
	"warningIconBackgroundColor": `var(--color-grey-1000)`,
	"warningIconExclamationColor": `var(--color-yellow-700)`,
	"hoverColor": `rgba(var(--color-blue-700), 0.3)`,
	"navigationButtonBackgroundHoverColor": `var(--color-blue-1000)`,
	"conditionToggleButtonBackgroundColor": `var(--color-grey-1000)`,
	"conditionToggleButtonBorderColor": `var(--color-grey-900)`,
	"conditionTableBackgroundColor": `var(--color-grey-1000)`,
	"conditionTableBorderColor": `var(--color-grey-900)`,
	"conditionTableNestedBackgroundColor": `var(--color-grey-1000)`,
	"modularPurpleColor": `var(--color-purple-600)`,
	"modularBackgroundPurpleColor": `var(--color-purple-1000)`,
	"readyToUseSkyBlueColor": `var(--color-sky-600)`,
	"readyToUseBackgroundBlueColor": `var(--color-blue-1000)`,
	"readyToUseBorderBlueColor": `var(--color-sky-900)`,
	"modularBorderPurpleColor": `var(--color-purple-950)`,
	"integrationGreenColor": `var(--color-green-400)`,
	"integrationBorderGreenColor": `var(--color-green-900)`,
	"integrationBackgroundGreenColor": `var(--color-green-950)`,
	"descriptionTextColor": `var(--color-grey-700)`,
	"lightGreenBackgroundColor": `var(--color-green-200)`,
	"lightBlueBackgroundColor": `var(--color-blue-200)`,
	"errorBannerColor": `var(--color-red-300)`,
	"errorBannerTextColor": `var(--color-grey-900)`,
	"bannerIconBackgroundColor": `var(--color-red-800)`,
	"bannerIconColor": `var(--color-white)`,
	"accordianSuccessBackgroundColor": `var(--color-green-950)`,
	"accordianSuccessBorderColor": `var(--color-green-950)`,
	"accordianSuccessTextColor": `var(--color-green-500)`,
	"cardBorderColor": `var(--color-grey-900)`,
	"navigationListDividerColor": `var(--color-grey-900)`,
	"userDefinedErrorColor": `var(--color-orange-950)`,
	"ruleGreenColor": `#096442`,
	"ruleYellowColor": `#987100`,
	"ruleBlueColor": `#0156a6`,
	"ruleRedColor": `#a51313`,
	"rulePurpleColor": `#453498`,
	"ruleOrangeColor": `#ca5600`,
	"rulePinkColor": `#c41796`,
	"ruleCyanColor": `#006e80`,
	"ruleGrayColor": `#646262`,
	"defaultTheme": `defaultTheme`,
	"tenantTheme": `tenantTheme`,
	"defaultDarkTheme": `defaultDarkTheme`,
	"tenantDarkTheme": `tenantDarkTheme`,
	"subTenantTheme": `subTenantTheme`,
	"subTenantDarkTheme": `subTenantDarkTheme`,
	"breakpointXs": `458px`,
	"breakpointSm": `580px`,
	"breakpointMd": `768px`,
	"breakpointLg": `992px`,
	"breakpointXl": `1200px`,
	"breakpointXxl": `1600px`,
	"file": `FwFC6vsu7YyG_5ihMugw`,
	"nestedFile": `LdGApVYJHTt8mQSAnQGE`,
	"xxxsGap": `DIRI5HRHVZgy8VAiYY77`,
	"xxxxsGap": `Q52q1Z6rhoJghYNNhNDI`,
	"iconButton": `Mcbs4ydBJllCpQ37lTeU`,
	"container": `WN2OOV34MeNGfAtBGZzw`,
	"scrollContainer": `licgqujb2c5P0QiwAvOw`,
	"archiveFolderContainer": `mAhnr3J4xT4YD_durQQQ`,
	"footer": `F9iMhMzjAUbZZESijHsF`
};
export default ___CSS_LOADER_EXPORT___;
